import Vue from "vue";
import Router from "vue-router";
import AuthLayout from "@/layouts/auth";
import JourneyBinderLayout from "@/layouts/journeybinder";
import SessionLayout from "@/layouts/session";
import store from "@/store";
Vue.use(Router);

const router = new Router({
  base: process.env.BASE_URL,
  mode: "history",
  routes: [
    {
      path: "/",
      redirect: "focus",
      component: JourneyBinderLayout,
      meta: { authRequired: true, hidden: true },
      children: [
        {
          path: "/focus",
          meta: {
            title: "my.journeybinder"
          },
          component: () => import("./views/binder/focus")
        },
        {
          path: "/me",
          meta: {
            title: "My Profile"
          },
          component: () => import("./views/binder/me")
        },
        {
          path: "/joins",
          meta: {
            title: "Crew Tracking"
          },
          component: () => import("./views/binder/joins")
        },
        {
          path: "/manage/guide",
          meta: {
            title: "Guide Management",
            activeGuideRequired: true,
            hidden: true
          },
          component: () => import("./views/binder/manage/guide")
        },
        {
          path: "/manage/blog",
          meta: {
            title: "Blog Management",
            activeBlogRequired: true,
            hidden: true
          },
          component: () => import("./views/binder/manage/blogger")
        },
        {
          path: "/manage/admin",
          meta: {
            title: "Admin Management",
            activeAdminRequired: true,
            hidden: true
          },
          component: () => import("./views/binder/manage/admin")
        },
        {
          path: "/manage/company",
          meta: {
            title: "Company Profile",
            activeCompanyRequired: true,
            hidden: true
          },
          component: () => import("./views/binder/manage/company")
        },
        {
          path: "/manage/developer",
          meta: {
            title: "Developer Profile",
            activeDeveloperRequired: true,
            hidden: true
          },
          component: () => import("./views/binder/manage/developer")
        },
        {
          path: "/tag/crew",
          meta: {
            title: "my.journeybinder"
          },
          component: () => import("./views/binder/tag/crew")
        },
        {
          path: "/tag/tools",
          meta: {
            title: "My Tools"
          },
          component: () => import("./views/binder/tag/tools")
        },
        {
          path: "/list/journeys",
          meta: {
            title: "My Journeys"
          },
          component: () => import("./views/binder/list/journeys")
        },
        {
          path: "/list/events",
          meta: {
            title: "my.journeybinder"
          },
          component: () => import("./views/binder/list/events")
        },
        {
          path: "/list",
          meta: {
            title: "Lists"
          },
          component: () => import("./views/binder/list")
        },
        {
          path: "/tag",
          meta: {
            title: "Tags"
          },
          component: () => import("./views/binder/tag")
        },
        {
          path: "/guides/apply",
          meta: {
            title: "Apply to become a guide"
          },
          component: () => import("./views/binder/guide/apply")
        },
        {
          path: "/guide/:guideProfileName",
          meta: {
            title: "Book a Session"
          },
          component: () => import("./views/binder/guide/book")
        },
        {
          path: "/refresh-account-link",
          meta: {
            title: "Refresh Link"
          },
          component: () => import("./views/app/refreshLink")
        }
      ]
    },
    {
      path: "/sessions",
      redirect: "/sessions",
      component: SessionLayout,
      children: [
        {
          path: "/sessions",
          meta: {
            title: "Sessions"
          },
          component: () => import("./views/binder/sessions")
        },
        {
          path: "/sessions/:guideName",
          meta: {
            title: "Session"
          },
          component: () => import("./views/binder/sessions")
        }
      ]
    },
    //_app- System Pages
    {
      path: "/app",
      component: AuthLayout,
      redirect: "/signin",
      children: [
        {
          path: "/signin",
          meta: {
            title: "Sign In"
          },
          component: () => import("./views/app/signin")
        },
        {
          path: "/signup",
          meta: {
            title: "Sign Up"
          },
          component: () => import("./views/app/signup")
        },
        {
          path: "/forgot-password",
          meta: {
            title: "Forgot Password"
          },
          component: () => import("./views/app/forgotPassword")
        },
        {
          path: "/system/404",
          meta: {
            title: "Error 404"
          },
          component: () => import("./views/app/404")
        },
        {
          path: "/system/500",
          meta: {
            title: "Error 500"
          },
          component: () => import("./views/app/500")
        }
      ]
    },
    // Redirect to 404
    {
      path: "*",
      redirect: "system/404",
      hidden: true
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.authRequired)) {
    if (!store.state.user.user) {
      next({
        path: "/signin",
        query: { redirect: to.fullPath }
      });
    } else {
      if (store.state.user.user.uid) {
        store.dispatch("user/getProfile").then(profile => {
          if (to.matched.some(record => record.meta.activeGuideRequired)) {
            if (
              profile._dashboards &&
              profile._dashboards.guide &&
              profile._dashboards.guide._account &&
              profile._dashboards.guide._account.status !== "active"
            ) {
              next({
                path: "/focus"
              });
            } else {
              next();
            }
          } else {
            next();
          }
          if (to.matched.some(record => record.meta.activeBlogRequired)) {
            if (
              profile._dashboards &&
              profile._dashboards.blogger &&
              profile._dashboards.blogger._account &&
              profile._dashboards.blogger._account.status !== "active"
            ) {
              next({
                path: "/focus"
              });
            } else {
              next();
            }
          } else {
            next();
          }
          if (to.matched.some(record => record.meta.activeAdminRequired)) {
            if (
              profile._dashboards &&
              profile._dashboards.admin &&
              profile._dashboards.admin._account &&
              profile._dashboards.admin._account.status !== "active"
            ) {
              next({
                path: "/"
              });
            } else {
              next();
            }
          } else {
            next();
          }
          if (to.matched.some(record => record.meta.activeCompanyRequired)) {
            if (
              profile._dashboards &&
              profile._dashboards.company &&
              profile._dashboards.company._account &&
              profile._dashboards.company._account.status !== "active"
            ) {
              next({
                path: "/"
              });
            } else {
              next();
            }
          } else {
            next();
          }
          if (to.matched.some(record => record.meta.activeDeveloperRequired)) {
            if (
              profile._dashboards &&
              profile._dashboards.developer &&
              profile._dashboards.developer._account &&
              profile._dashboards.developer._account.status !== "active"
            ) {
              next({
                path: "/"
              });
            } else {
              next();
            }
          } else {
            next();
          }
        });
      } else {
        next();
      }
    }
  } else {
    next();
  }
});

export default router;
